import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, Card, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

export default function HistoricTabs() {
  const [activeDisplayOption, setActiveDisplayOption] = useState('total_debt');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const displayOptions = useMemo(
    () => [
      { key: 'total_debt', value: 'Total debt' },
      { key: 'total_underwater_wallets', value: 'N° of underwater wallets' }
    ],
    []
  );

  const [data, error] = useApi<SimpleChartData[]>({
    url: `/overall/history/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      <HistoricGraphs
        data={data}
        activeDisplayOption={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    </Card>
  );
}
